import { render } from "./BaseButtonGroup.vue?vue&type=template&id=13bc8db7&scoped=true"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=ts"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=ts"

import "./BaseButtonGroup.vue?vue&type=style&index=0&id=13bc8db7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13bc8db7"

export default script